const actionTypeIdentifier = 'F9CC1C8A-5294-46B9-9672-22B2959D597A';

export const getInventoryUsageSpend = `GET-INVENTORY-USAGE-SPEND-${actionTypeIdentifier}`;
export const setInventoryUsageSpendError = `SET-INVENTORY-USAGE-SPEND-ERROR-${actionTypeIdentifier}`;